module.exports = __webpack_public_path__ + "img/empty_tabel.6ab68ada.png";